import React, { useState } from 'react';
import { View, Text, Pressable, StyleSheet, ScrollView } from '../lib/react-native-compat';
import LaborClassification from './laborClassification';
import LaborGraphs from './laborGraphs';
import EarnedVsBurned from './earnedVsBurned';
import WipVariance from './wipVariance';

const LaborDashboard = () => {
    const [activeTab, setActiveTab] = useState('Labor S Curve');
    const tabs = ['Labor S Curve', 'Labor Ratios', 'Earned vs Burned', 'Hour WIP Variance'];

    return (
        <View>
            <View style={styles.container}>
                <ScrollView horizontal showsHorizontalScrollIndicator={false}>
                    <View style={{ flexDirection: 'row', gap: 20, marginLeft: 10, height: 42 }}>
                        {tabs.map((tab) => (
                            <Pressable
                                key={tab}
                                onPress={() => setActiveTab(tab)}
                                style={[
                                    styles.tabItem,
                                    {
                                        paddingVertical: 12,
                                        paddingHorizontal: 16,
                                        borderBottom: activeTab === tab ? '2px solid #2563eb' : '2px solid transparent',
                                        justifyContent: 'center',
                                    }
                                ]}
                            >
                                <Text style={[styles.tabText, activeTab === tab && styles.activeText]}>
                                    {tab}
                                </Text>
                            </Pressable>
                        ))}
                    </View>
                </ScrollView>
            </View>
            {activeTab === 'Labor Ratios' ? <LaborClassification /> : activeTab === 'Earned vs Burned' ? <EarnedVsBurned /> : activeTab === 'Hour WIP Variance' ? <WipVariance /> : <LaborGraphs />}

        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
        paddingLeft: 20,
        paddingTop: 8,
        borderBottom: '1px solid #e2e8f0',
    },
    tabItem: {
        paddingVertical: 12,
        paddingHorizontal: 16,
    },
    activeTab: {
        borderBottomColor: '#2563eb',
    },
    tabText: {
        fontSize: 14,
        color: '#6b7280',
        fontWeight: '400',
    },
    activeText: {
        color: '#2563eb',
        fontWeight: '500',
    },
    content: {
        padding: 20,
    },
    contentText: {
        fontSize: 16,
    },
});

export default LaborDashboard;

